var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.dialogVisible,
        width: "625px",
        "before-close": _vm.handleClose,
        "custom-class": "dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.formInfo,
            rules: _vm.rules,
            "label-width": "140px",
            "label-position": "right",
          },
        },
        [
          _vm.versionAddOrEdit === "add" && _vm.activeName !== "IOS"
            ? _c(
                "el-form-item",
                { attrs: { label: "应用包", prop: "package" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        action: "ota/v1/app/version/info/upload/version/file",
                        headers: _vm.headers,
                        "before-upload": _vm.beforeUpload,
                        "on-success": _vm.uploadSuccess,
                        "on-error": _vm.uploadError,
                        data: { appInfoId: _vm.appInfoId },
                        multiple: "",
                        accept: _vm.uploadFileType,
                      },
                    },
                    [
                      !_vm.uploadSuccessedFile
                        ? _c(
                            "el-button",
                            {
                              staticClass: "upload-btn",
                              attrs: { size: "small", icon: "el-icon-plus" },
                            },
                            [
                              _vm._v(
                                "上传" + _vm._s(_vm.uploadFileType) + "文件"
                              ),
                            ]
                          )
                        : _c(
                            "el-input",
                            {
                              staticClass: "file-name",
                              model: {
                                value: _vm.formInfo.fileName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formInfo, "fileName", $$v)
                                },
                                expression: "formInfo.fileName",
                              },
                            },
                            [_vm._v(_vm._s(_vm.formInfo.fileName))]
                          ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.activeName !== "IOS"
            ? _c("el-form-item", { attrs: { label: "版本号" } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.formInfo.versionCode || "-") +
                    "\n    "
                ),
              ])
            : _vm._e(),
          _vm.activeName !== "IOS"
            ? _c(
                "el-form-item",
                { attrs: { label: "包体大小", prop: "AndroidName" } },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.formInfo.packageSize / 1024 / 1024 || "-") +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm.activeName !== "IOS"
            ? _c(
                "el-form-item",
                { attrs: { label: "MD5值", prop: "iosName" } },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.formInfo.md5 || "-") + "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm.activeName === "IOS"
            ? _c(
                "el-form-item",
                { attrs: { label: "版本号", prop: "version" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入版本号" },
                    model: {
                      value: _vm.formInfo.versionCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.formInfo, "versionCode", $$v)
                      },
                      expression: "formInfo.versionCode",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "提示频率", prop: "frequency" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.formInfo.frequency,
                    callback: function ($$v) {
                      _vm.$set(_vm.formInfo, "frequency", $$v)
                    },
                    expression: "formInfo.frequency",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("每天")]),
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("每次")]),
                  _c("el-radio", { attrs: { label: 2 } }, [_vm._v("每三天")]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "更新日志", prop: "description" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  maxlength: "200",
                  "show-word-limit": "",
                  placeholder: "请输入更新日志",
                  rows: 4,
                },
                model: {
                  value: _vm.formInfo.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.formInfo, "description", $$v)
                  },
                  expression: "formInfo.description",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "14" }, on: { click: _vm.handleClose } },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "14" },
              on: { click: _vm.onSubmit },
            },
            [_vm._v("确 定\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }